import ThemedIcon from '@components/ThemedIcon';
import { Loader } from '@components/payment/Loader';
import Block from '@components/Block';
import { inter } from '@components/Layout/consts.tsx';

const OrderLoadingPage = () => {
  return (
    <div
      className={`fadeIn relative flex h-full min-h-screen w-full min-w-[350px] justify-center overflow-auto bg-bg-primary md:p-8 ${inter.className}`}
    >
      <div className='flex h-full min-h-fit w-full flex-col gap-4 px-4 py-6 md:h-auto md:w-174 md:p-0'>
        <ThemedIcon name='app-logo' className='self-center' />

        <div className='flex flex-1 flex-col justify-center'>
          <Loader
            className='mb-4 h-8 w-full self-center p-0 md:h-10 md:w-80'
            variant='secondary'
          />

          <div className='mb-2'>
            <Loader variant='secondary' className='h-2 w-full p-0' />
          </div>

          <Loader
            variant='secondary'
            className='mb-2 h-36 w-full items-start p-6 md:mb-4'
          />

          <div className='mb-2 grid grid-cols-1 gap-2 md:mb-4 md:grid-cols-2 md:gap-4'>
            <Block className='relative flex-1'>
              <Loader className='mb-2 h-2 w-40' />
              <div className='mt-2 flex items-center justify-between'>
                <Loader className='h-4 w-48' />
                <div className='h-8 w-8 rounded-2xl bg-decorative-icon-bg-primary' />
              </div>
            </Block>
            <Block className='relative flex-1'>
              <Loader className='mb-2 h-2 w-32' />
              <div className='mt-2 flex items-center justify-between'>
                <Loader className='h-4 w-36' />
                <div className='h-8 w-8 rounded-2xl bg-decorative-icon-bg-primary' />
              </div>
            </Block>
          </div>

          <div className='relative mb-4 grid grid-cols-1 gap-2 bg-none md:mb-8 md:grid-cols-2 md:gap-4 md:after:absolute md:after:bottom-[-1rem] md:after:left-0 md:after:right-0 md:after:h-[1px] md:after:bg-border-subtle'>
            <Block className='flex items-center gap-4'>
              <div className='h-20 min-h-20 w-28 min-w-28 rounded-lg bg-gray-100' />
              <Loader className='h-16 w-full' />
            </Block>
            <Block className='flex flex-col gap-2 md:gap-4'>
              <Loader className='h-8 w-full rounded-lg' />
              <Loader className='h-8 w-full rounded-lg' />
            </Block>
          </div>

          <Block variant='secondary' className='w-full'>
            <Loader className='mb-2 h-4 w-28' />
            <div className='flex flex-row flex-wrap items-center justify-between gap-1'>
              <div className='flex flex-col gap-2'>
                <Loader className='h-5 w-80' />
                <Loader className='mt-2 h-3 w-36' />
              </div>
              <div className='h-8 w-8 rounded-2xl bg-decorative-icon-bg-primary' />
            </div>
          </Block>

          <div className='sticky bottom-0 left-0 mt-auto hidden  items-stretch justify-center gap-4 bg-bg-primary pb-4 pt-6 md:static md:mt-6 md:flex md:pt-0'>
            <Loader
              className='h-14 w-full rounded-xl md:flex-1'
              variant='secondary'
            />
            <Loader
              className='h-14 w-full rounded-xl md:flex-1'
              variant='secondary'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderLoadingPage;
